<td><strong>{{ fileView.name }}</strong></td>
<td class="w-10">{{ fileView.size/1024/1024 | number:'.2' }} MB</td>
<td class="w-20">
    <div class="progress" style="margin-bottom: 0;">
        <mat-progress-bar class="progress-bar" mode="determinate" progressbarId="fileView.id"
                          [value]="fileView.progress" *ngIf="fileView.progress">
        </mat-progress-bar>
    </div>
</td>
<td class="w-20">
    <span>{{fileView.status}}</span>
</td>
<td class="w-10">
    <div class="file-action-buttons" #buttons>
        <button type="button" class="btn btn-primary btn-xs" [disabled]="disableAllButtonsRow || fileView.disableAllButtons || fileView.disableUploadButton"
                (click)="rowClicked(typeButton.UPLOAD)">
            <span class="glyphicon glyphicon-upload"></span>
        </button>
        <button type="button" class="btn btn-primary btn-xs" [disabled]="disableAllButtonsRow || fileView.disableAllButtons"
                (click)="rowClicked(typeButton.DELETE)">
            <span class="glyphicon glyphicon-trash"></span>
        </button>
    </div>
</td>
